module.exports = __webpack_public_path__ + "static/1-009-bd4bde4191ffa98aa07138126b632b57.png";